export default {
  "contacts" : true,
  'games': false,
  'news': false,
  'partners': false,
  'company': false
}
